import { call, take, put }          from 'redux-saga/effects';
import axios                        from 'axios';
import { 
         SET_CONTENT,
         UPDATE_STUDENT_SCORES,
         UPDATE_TOTAL_LIKES,
         UPDATE_ACTIVITY,
         UPDATE_GUEST_DATA,
         RECORD_ERROR_SAGA
       }                            from 'actions';

import { make_hash }                from 'functions/set_data/make_hash';
import { make_all_content_arr }     from 'functions/set_data/make_all_content_arr';
import { makeGuestApps }            from 'functions/rectify_data/make_guest_apps';
import filterGrades                 from 'functions/rectify_data/filter_grades';
import { 
  setLessonsFormat,
  setPuzzlesFormat
}                                   from 'functions/rectify_data/set_lessons_format';

import mockApps                     from 'content/mockContent/apps2';
import mockLessons                  from 'content/mockContent/lessons2';
import { mockPuzzles }              from 'content/mockContent/puzzles';
import mockInteraction              from 'content/mockContent/interaction';
import { appsArr, lessonsArr }      from 'content/guest';


const appsEndpoint        = 'https://www.yisumatica.org.il/yisumaticaApi/getApps.php';
const lessonsEndpoint     = 'https://www.yisumatica.org.il/yisumaticaApi/getLessons.php';
const puzzlesEndpoint     = 'https://www.yisumatica.org.il/yisumaticaApi/getPuzzles.php';
const interactionEndpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getInteraction.php';



const addPuzzleId = (arr: { [key: string]: any }) => {
  for ( let i = 0; i < arr.length; i++ ) {
      arr[i].puzzle_id = `${ !!arr[i].lesson_id ? arr[i].lesson_id : '' }${ !!arr[i].extra_url ? arr[i].extra_url : '' }`;
  }

  return arr;

}


function* getContent(): Generator<any,any,any> {
  while(true) {
    try {

      const userInput = yield take('GET_CONTENT_SAGA');

      const { userIsGuest, gradeAccess  } = userInput.payload;

      if ( process.env.NODE_ENV === 'development' ) {

        console.log('GET_CONTENT_SAGA')

      //  const homePageApp          = userIsGuest ? [] : mockApps.filter((val) => { return !!val.lesson_id &&  val.lesson_id === "Fractions_bingo_2" })
        const apps__               = userIsGuest ? makeGuestApps(mockApps, appsArr) : mockApps;
        const lessons__            = userIsGuest ? makeGuestApps(mockLessons, lessonsArr) : mockLessons;

        const apps_filtered        =  yield filterGrades(gradeAccess, true,  apps__ ); 
        const lessons_filtered     =  yield filterGrades(gradeAccess, true,  lessons__ ); 
        const puzzles_filtered     =  yield filterGrades(gradeAccess, true,  mockPuzzles ); 
        const interaction_filtered =  yield filterGrades(gradeAccess, true,  mockInteraction ); 
                
        const appsHash:            { [key: string]: any } = yield make_hash(apps_filtered);
        const mockLessonsFinal:    { [key: string]: any } = yield setLessonsFormat(appsHash, lessons_filtered);
        const mockPuzzlesFiltered: { [key: string]: any } = yield setPuzzlesFormat(puzzles_filtered);
        const mockPuzzlesFinal:    { [key: string]: any } = yield addPuzzleId(mockPuzzlesFiltered);

        const bigContentArr:       { [key: string]: any }[] = apps_filtered.concat(mockLessonsFinal).concat(mockPuzzlesFinal).concat(interaction_filtered).filter((val: any) => { return(!(val.youtube && val.youtube === 'hide')) });

        const allContent           =  make_all_content_arr('content', bigContentArr)

        const hash: { [key: string]: any } = yield make_hash(allContent);

        const payload = {
            bigContentArr:         bigContentArr,
            apps:                  apps_filtered,
            interaction:           interaction_filtered,
            puzzles:               mockPuzzlesFinal,
            lessons:               mockLessonsFinal,
            hash:                  hash,
            contentUpdated:        true,
            storageContentUpdated: true,
            sender:                'getContent'
        }

        yield put(SET_CONTENT( payload ))

        if ( userIsGuest ) {
          yield put(UPDATE_STUDENT_SCORES(true));
          yield put(UPDATE_TOTAL_LIKES())
          yield put(UPDATE_ACTIVITY())
          yield put(UPDATE_GUEST_DATA())
          yield put(SET_CONTENT({ contentUpdated: true, sender: 'getContent' }))
        }
        

      }


      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
      // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   


      if (process.env.NODE_ENV === 'production') {

                // send request to DB
  
                const apps         = yield call( axios.post, appsEndpoint, {} );
                const lessons      = yield call( axios.post, lessonsEndpoint, {} );
                const puzzles      = yield call( axios.post, puzzlesEndpoint, {} );
                const interactions = yield call( axios.post, interactionEndpoint, {} );

                if (
                      apps         && apps.data         && apps.data.result &&
                      lessons      && lessons.data      && lessons.data.result &&
                      puzzles      && puzzles.data      && puzzles.data.result &&
                      interactions && interactions.data && interactions.data.result
                   ) {

                    const responseApps         = apps.data.result;
                    const responseLessons      = lessons.data.result;
                    const responsePuzzles      = puzzles.data.result;
                    const responseInteractions = interactions.data.result;



                    const apps_filtered        = yield filterGrades(gradeAccess, true, responseApps);
                    const lessons_filtered     = yield filterGrades(gradeAccess, true, responseLessons);
                    const puzzles_filtered     = yield filterGrades(gradeAccess, true, responsePuzzles);
                    const interaction_filtered = yield filterGrades(gradeAccess, true, responseInteractions);


                    const apps_:         { [key: string]: any }[] = userIsGuest ? makeGuestApps(apps_filtered, appsArr) : apps_filtered;
                    const lessons_:      { [key: string]: any }[] = userIsGuest ? makeGuestApps(lessons_filtered, lessonsArr) : lessons_filtered;

                    const appsHash:     { [key: string]: any } = yield make_hash(apps_);
                    const lessonsFinal: { [key: string]: any } = yield setLessonsFormat(appsHash, lessons_);
                    const puzzlesFormat:{ [key: string]: any } = yield setPuzzlesFormat(puzzles_filtered);
                    const puzzlesFinal: { [key: string]: any } = yield addPuzzleId(puzzlesFormat);

  
                    const bigContentArr: { [key: string]: any }[] = apps_.concat(lessonsFinal).concat(puzzlesFinal).concat(interaction_filtered).filter((val) => { return(!(val.youtube && val.youtube === 'hide')) });

                    const allContent =  make_all_content_arr('content', bigContentArr)
  
                    const hash: { [key: string]: any } = yield make_hash(allContent);
  
                    const payload = {
                        bigContentArr:         bigContentArr,
                        apps:                  apps_,
                        interaction:           interaction_filtered,
                        puzzles:               puzzlesFinal,
                        lessons:               lessonsFinal,
                        hash:                  hash,
                        contentUpdated:        true,
                        storageContentUpdated: true,
                        sender:                'getContent'
                    }

                   // console.log('puzzlesFinal : ',JSON.stringify(puzzlesFinal, null, 2))
                    
  
                    yield put(SET_CONTENT( payload ))

                    if ( userIsGuest ) {
                      yield put(UPDATE_STUDENT_SCORES(true));
                      yield put(UPDATE_TOTAL_LIKES())
                      yield put(UPDATE_ACTIVITY())
                      yield put(UPDATE_GUEST_DATA())
                      yield put(SET_CONTENT({ contentUpdated: true, sender: 'getContent' }))
                    }

                }

        }
      
      

    }
    catch(err) {
      yield put(RECORD_ERROR_SAGA({ data: { error: err }, endpoint: 'get content saga' }))
      console.log('err at get content saga  :  '+err);

    }
    finally {}
  }
}


export default getContent;




